<template>
  <div class="speech-evaluation-component">
    <div class="speech-evaluation-content">
      <div v-safe-html="processedSpeechEvaluationText" class="sls-speech-evaluation" />
    </div>
    <attachment-placeholder v-if="showActionTools">
      <template #action-tools>
        <button class="edit" type="button">
          <svg-icon name="Pencil24" kind="action" />
        </button>
        <button class="trash" type="button">
          <svg-icon name="Trash24" kind="action" />
        </button>
      </template>
    </attachment-placeholder>
  </div>
</template>

<script setup lang="ts">
import AttachmentPlaceholder from "@plugins/common/components/AttachmentPlaceholder.vue";
import SvgIcon from "@plugins/common/components/SvgIcon.vue";
import { useDynamicMountChild } from "@plugins/common/composables/dynamic-mount-child.ts";
import { computed } from "vue";
import RichTextUtils from "@plugins/richtext/utils/richtext.utils";

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<{
    speechEvaluationText?: string;
    showActionTools?: boolean;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_parentComponent?: object;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_isDynamicallyMounted?: boolean;
  }>(),
  {
    speechEvaluationText: "",
    showActionTools: false,
    dynamicMountChildMixin_parentComponent: () => ({}),
    dynamicMountChildMixin_isDynamicallyMounted: false,
  },
);

useDynamicMountChild({
  dynamicMountChildMixin_parentComponent: props.dynamicMountChildMixin_parentComponent,
  dynamicMountChildMixin_isDynamicallyMounted: props.dynamicMountChildMixin_isDynamicallyMounted,
});

const processedSpeechEvaluationText = computed(() => {
  if (!props.showActionTools) {
    return props.speechEvaluationText;
  }
  const container = document.createElement("div");
  container.innerHTML = props.speechEvaluationText;
  RichTextUtils.processToPreserveLineBreaks(container);
  return container.innerHTML;
});
</script>
